module.exports = __webpack_public_path__ + "static/media/27.1691e86f.JPG";